import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: 605,
    width: "100%",
    margin: "0 auto",
    padding: theme.spacing(2.5, 0),
    borderTop: "1px solid #DADADA",
    borderBottom: "1px solid #DADADA",
  },
  userDetails: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(3),
    cursor: "pointer",
  },
  userAvatar: {
    width: 26,
    height: 26,
  },
  userDetailsRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.spacing(1),
  },
  username: {
    fontSize: "0.625rem",
  },
  userStats: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  userStat: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  contentRight: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2.5),
  },
  createdAt: {
    fontSize: "0.625rem",
    color: "#757575",
  },
  iconButton: {
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.secondary.main,
    },
  },
}));
